import type { LucideIcon } from "@/components/icons"

import { Card, CardContent } from "@/components/ui/card"
import { EmptyState } from "@/components/ui/empty-state"
import { TableCell, TableRow } from "@/components/ui/table"

interface EmptyStateCardProps {
  icon: LucideIcon
  title: string
  description: string
  className?: string
}

export function EmptyStateCard({ icon: Icon, title, description, className }: EmptyStateCardProps) {
  return (
    <Card className={`rounded-lg shadow-sm ${className || ""}`}>
      <CardContent className="py-8">
        <EmptyState description={description} icon={Icon} title={title} />
      </CardContent>
    </Card>
  )
}

interface EmptyTableRowProps {
  colSpan: number
  message: string
}

export function EmptyTableRow({ colSpan, message }: EmptyTableRowProps) {
  return (
    <TableRow>
      <TableCell className="text-muted-foreground text-center" colSpan={colSpan}>
        {message}
      </TableCell>
    </TableRow>
  )
}

// Generate translated empty state configurations
